<template>
  <div class="page">
    <div
      class="card"
      :class="{ '-loading': loading }"
    >
      <loader v-if="loading"></loader>

      <div class="header">
        <div class="description">
          <h2 class="title">Consultas</h2>
          <p class="subtitle"> Nesta tela você visualiza as consultas habilitadas e desabilitadas.</p>
        </div>

        <card-actions>
          <router-link
            :to="{ name: 'Endpoint-Create' }"
            class="btn btn-primary -sm"
          >Cadastrar Consulta<ion-icon name="add"></ion-icon></router-link>
        </card-actions>
      </div>
      <div
        class="body"
        :class="{ '-no-padding': !errors.cantLoadEndpointList }"
      >
        <div class="alert -danger" v-if="errors.cantLoadEndpointList">
          <p class="title">Ops!</p>

          <p>
            Infelizmente aconteceu um erro ao tentar carregar o seu histórico,
            por favor tente novamente ou contate nossa equipe.
          </p>
        </div>

        <div class="row pl-5 pr-5">
          <div class="form-group">
            <label for="search" class="label">Pesquisa</label>
            <input
              type="text"
              id="search"
              name="search"
              class="form-control"
              placeholder="Nome da consulta"
              v-model="query"
              @keyup="search"
            >
          </div>
        </div>

        <template v-if="!errors.cantLoadEndpointList">
          <table class="endpoint">
            <thead>
            <tr>
              <th>Nome</th>
              <th>Habilitado?</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="endpoint in filteredEndpoints" v-show="filteredEndpoints.length > 0">
              <td>{{ endpoint.label }}</td>
              <td>
                <div class="badge" v-bind:class="[ endpoint.enable ? '-success' : '-danger' ]">
                  {{ endpoint.enable ? 'Sim' : 'Não' }}
                </div>
              </td>
              <td>
                <router-link
                  :to="{ name: 'Endpoint-Edit', params: { id: endpoint.id } }"
                  class="btn btn-primary -sm mr-2"
                >
                  Editar
                </router-link>

                <button type="button" class="btn -sm" v-bind:class="[ endpoint.enable ? 'btn-danger' : 'btn-success' ]"
                  @click="toggle(endpoint.id)">
                  {{ endpoint.enable ? 'Desabilitar' : 'Habilitar' }}
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import currency from '@/support/filters/currency';
import Loader from '@/support/components/Loader.vue';
import CardActions from '@/support/components/card/CardActions.vue';

export default {
  name: 'Index',

  data() {
    return {
      loading: false,
      errors: {
        cantLoadEndpointList: false,
      },
      query: '',
      filteredEndpoints: [],
    };
  },

  methods: {
    /**
     * Fetch the  endpoint list.
     *
     * @returns {Promise<void>}
     */
    async fetchEndpointList() {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch('endpoint/fetchEndpointList');
        this.search();
      } catch {
        this.errors.cantLoadEndpointList = true;
      } finally {
        this.loading = false;
      }
    },

    async toggle(id) {
      try {
        this.loading = true;

        await this.$store.dispatch('endpoint/toggleEndpoint', { id });
        await this.fetchEndpointList();
      } finally {
        this.loading = false;
      }
    },

    search() {
      this.filteredEndpoints = this.endpoints.filter((endpoint) => endpoint.label.toLowerCase().includes(this.query.toLowerCase()));
    },

    /**
     * Reset the all errors to initial value.
     */
    resetErrors() {
      this.errors.cantLoadEndpointList = false;
    },
  },

  computed: {
    ...mapState('endpoint', {
      endpoints: 'endpoints',
    }),
  },

  mounted() {
    this.fetchEndpointList();
  },

  filters: {
    currency,
  },

  components: {
    Loader,
    CardActions,
  },
};
</script>

<style lang="scss" scoped>
.page {
  > .card {
    > .body {
      > .navHistory {
        @apply flex;
        @apply justify-center;
      }
    }
  }
}
.endpoint > tbody > tr:hover td {
  @apply bg-primary-50;
  @apply bg-opacity-25;
}
</style>
